import BCDLogo from '../assets/BCDTravel_Logo-FC.png';
import fk from '../assets/finkraft_logo_new.png';
import React, { useEffect, useState, useRef, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import { Modal, Input, Button } from "antd";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import 'ag-grid-enterprise';
import cal from '../assets/calendar.png';
import { DownloadOutlined, LogoutOutlined, ReloadOutlined } from '@ant-design/icons';
import { Typography } from "antd";
import "./TmcDataTable.scss";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { Spin } from "antd";

const BASE_URL = "https://bcd-prospect-admin.finkraftai.com/api";

const pmOptionsFallback = [
  'Satvir', 'Kashik', 'Ryan', 'Ankita', 'Anul', 'Asha', 'Reema',
  'Jackson', 'Jayan', 'Manish', 'Nithini', 'Shilpa', 'Suzzane', 'Branch', 'No Value'
];

const globalStyles = `
  .section-nav {
    display: flex; align-items: center; gap: 4px;
    background: #eef2f7; border-radius: 16px; padding: 6px;
    margin-bottom: 20px; width: fit-content;
    box-shadow: 0 1px 6px rgba(0,0,0,0.07);
  }
  .section-tab {
    display: flex; align-items: center; gap: 9px;
    padding: 11px 30px; border-radius: 12px; border: none;
    background: transparent; cursor: pointer; font-size: 14.5px;
    font-weight: 600; color: #6b7280; letter-spacing: 0.2px;
    transition: all 0.2s cubic-bezier(0.4,0,0.2,1);
    white-space: nowrap; user-select: none;
  }
  .section-tab:hover:not(.active) { color: #374151; background: rgba(255,255,255,0.55); }
  .section-tab.active { background: #fff; color: #0a8394; box-shadow: 0 2px 10px rgba(10,131,148,0.14), 0 1px 4px rgba(0,0,0,0.07); }
  .section-tab.gst-tab.active { color: #6366f1; }
  .section-tab svg { flex-shrink: 0; }
  .tab-badge {
    display: inline-flex; align-items: center; justify-content: center;
    min-width: 22px; height: 22px; padding: 0 6px; border-radius: 20px;
    font-size: 11.5px; font-weight: 700; background: #dff4f6; color: #0a8394;
    margin-left: 2px; transition: all 0.2s;
  }
  .section-tab.active .tab-badge { background: #0a8394; color: #fff; }
  .section-tab.gst-tab .tab-badge { background: #ede9fe; color: #6366f1; }
  .section-tab.gst-tab.active .tab-badge { background: #6366f1; color: #fff; }

  .card-section { display: flex; gap: 16px; margin-bottom: 18px; }
  .fk-stat-card {
    flex: 1; border-radius: 16px; overflow: hidden; cursor: pointer;
    transition: box-shadow 0.18s ease, transform 0.18s ease;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  }
  .fk-stat-card:hover { box-shadow: 0 6px 24px rgba(0,0,0,0.13); transform: translateY(-2px); }
  .fk-stat-card.selected-card { box-shadow: 0 0 0 2.5px #0a8394, 0 6px 24px rgba(10,131,148,0.18) !important; transform: translateY(-2px); }
  .fk-card-header-band { padding: 12px 16px 11px; display: flex; align-items: center; justify-content: space-between; }
  .action-card .fk-card-header-band { background: linear-gradient(135deg,#dc2626 0%,#f97316 100%); }
  .good-card  .fk-card-header-band { background: linear-gradient(135deg,#059669 0%,#0891b2 100%); }
  .fk-card-header-left { display: flex; align-items: center; gap: 8px; }
  .fk-card-title { font-size: 12.5px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; margin: 0; color: #fff; }
  .fk-card-total-badge {
    font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 20px;
    color: rgba(255,255,255,0.95); background: rgba(255,255,255,0.22);
    border: 1px solid rgba(255,255,255,0.3); backdrop-filter: blur(4px);
  }
  .fk-card-body { background: #fff; padding: 12px 14px 14px; border: 1px solid #e8edf3; border-top: none; border-radius: 0 0 16px 16px; }
  .fk-card-rows { display: flex; flex-direction: column; gap: 7px; }
  .fk-row-item {
    display: flex; align-items: center; gap: 10px;
    padding: 9px 11px 9px 13px; border-radius: 10px;
    border-left: 3.5px solid transparent; cursor: pointer; transition: all 0.15s ease;
  }
  .fk-row-item.type-prospect    { background:#eff6ff; border-left-color:#3b82f6; }
  .fk-row-item.type-demodone    { background:#f0fdf4; border-left-color:#22c55e; }
  .fk-row-item.type-lost        { background:#fff1f2; border-left-color:#f43f5e; }
  .fk-row-item.type-partnership { background:#f5f3ff; border-left-color:#8b5cf6; }
  .fk-row-item.type-direct      { background:#fffbeb; border-left-color:#f59e0b; }
  .fk-row-item.type-lostby      { background:#f8fafc; border-left-color:#94a3b8; }
  .fk-row-item.type-prospect:hover    { background:#dbeafe; }
  .fk-row-item.type-demodone:hover    { background:#dcfce7; }
  .fk-row-item.type-lost:hover        { background:#ffe4e6; }
  .fk-row-item.type-partnership:hover { background:#ede9fe; }
  .fk-row-item.type-direct:hover      { background:#fef3c7; }
  .fk-row-item.type-lostby:hover      { background:#f1f5f9; }
  .fk-row-item.active-item { filter: brightness(0.94); }
  .fk-row-item.type-prospect.active-item    { box-shadow: inset 0 0 0 1.5px #3b82f6; }
  .fk-row-item.type-demodone.active-item    { box-shadow: inset 0 0 0 1.5px #22c55e; }
  .fk-row-item.type-lost.active-item        { box-shadow: inset 0 0 0 1.5px #f43f5e; }
  .fk-row-item.type-partnership.active-item { box-shadow: inset 0 0 0 1.5px #8b5cf6; }
  .fk-row-item.type-direct.active-item      { box-shadow: inset 0 0 0 1.5px #f59e0b; }
  .fk-row-item.type-lostby.active-item      { box-shadow: inset 0 0 0 1.5px #94a3b8; }
  .fk-type-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  .dot-prospect{background:#3b82f6;} .dot-demodone{background:#22c55e;}
  .dot-lost{background:#f43f5e;} .dot-partnership{background:#8b5cf6;}
  .dot-direct{background:#f59e0b;} .dot-lostby{background:#94a3b8;}
  .fk-row-label { flex:1; font-size:12.5px; font-weight:600; color:#1e293b; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .fk-row-count {
    display:inline-flex; align-items:center; justify-content:center;
    min-width:26px; height:20px; padding:0 7px; border-radius:20px; font-size:11px; font-weight:700; flex-shrink:0;
  }
  .fk-row-item.type-prospect    .fk-row-count { background:#bfdbfe; color:#1d4ed8; }
  .fk-row-item.type-demodone    .fk-row-count { background:#bbf7d0; color:#15803d; }
  .fk-row-item.type-lost        .fk-row-count { background:#fecdd3; color:#be123c; }
  .fk-row-item.type-partnership .fk-row-count { background:#ddd6fe; color:#6d28d9; }
  .fk-row-item.type-direct      .fk-row-count { background:#fde68a; color:#92400e; }
  .fk-row-item.type-lostby      .fk-row-count { background:#e2e8f0; color:#475569; }
  .fk-row-revenue { font-size:12.5px; font-weight:700; color:#0f172a; flex-shrink:0; text-align:right; }
  .fk-row-chevron { font-size:13px; flex-shrink:0; opacity:0.4; transition:opacity 0.15s; }
  .fk-row-item:hover .fk-row-chevron { opacity:0.8; }
  .fk-hotel-grid { display:flex; gap:8px; }
  .fk-hotel-stat {
    flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center;
    gap:6px; padding:16px 8px 14px; border-radius:11px; cursor:pointer;
    transition:all 0.16s ease; min-width:0; text-align:center; border:2px solid transparent;
  }
  .fk-hotel-stat:hover { transform:translateY(-2px); box-shadow:0 4px 14px rgba(0,0,0,0.12); }
  .fk-hotel-stat.active-stat { border-color:rgba(0,0,0,0.25)!important; box-shadow:0 4px 14px rgba(0,0,0,0.18); }
  .fk-hotel-stat.type-prospect    { background:linear-gradient(145deg,#2563eb,#3b82f6); }
  .fk-hotel-stat.type-demodone    { background:linear-gradient(145deg,#16a34a,#22c55e); }
  .fk-hotel-stat.type-lost        { background:linear-gradient(145deg,#e11d48,#f43f5e); }
  .fk-hotel-stat.type-partnership { background:linear-gradient(145deg,#7c3aed,#8b5cf6); }
  .fk-hotel-stat.type-direct      { background:linear-gradient(145deg,#d97706,#f59e0b); }
  .fk-hotel-stat.type-lostby      { background:linear-gradient(145deg,#475569,#64748b); }
  .fk-hotel-count { font-size:28px; font-weight:800; color:#fff; line-height:1; text-shadow:0 1px 4px rgba(0,0,0,0.15); }
  .fk-hotel-label { font-size:10px; font-weight:700; color:rgba(255,255,255,0.88); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:100%; text-transform:uppercase; letter-spacing:0.5px; }

  /* ── Pinned totals row ── */
  .ag-theme-alpine .ag-row-pinned {
    background: #f0f9fa !important;
    border-top: 2px solid #0a8394 !important;
    font-weight: 700 !important;
    font-size: 13px !important;
  }
  .ag-theme-alpine .ag-row-pinned .ag-cell {
    color: #0a8394 !important;
  }
`;

const Dashboard = () => {
  const tmcName = "BCD";
  const clientTypeOptions = ['PROSPECT', 'Demo Done', 'Partnership', 'Lost', 'Direct', `Lost By ${tmcName}`];

  const [activeSection, setActiveSection] = useState('airline');
  const activeSectionRef = useRef('airline');
  const { Title, Text } = Typography;

  const [airlinePmOptions, setAirlinePmOptions] = useState([...pmOptionsFallback]);
  const [hotelPmOptions, setHotelPmOptions]     = useState([...pmOptionsFallback]);
  const [gstPmOptions, setGstPmOptions]         = useState([...pmOptionsFallback]);

  const [airlineRowData, setAirlineRowData]     = useState([]);
  const [airlineColDefs, setAirlineColDefs]     = useState([]);
  const [airlineLoading, setAirlineLoading]     = useState(false);
  const [airlinePeriods, setAirlinePeriods]     = useState([]);
  const [airlineSelectedPeriod, setAirlineSelectedPeriod] = useState("");

  const [hotelRowData, setHotelRowData]         = useState([]);
  const [hotelColDefs, setHotelColDefs]         = useState([]);
  const [hotelLoading, setHotelLoading]         = useState(false);
  const [hotelPeriods, setHotelPeriods]         = useState([]);
  const [hotelSelectedPeriod, setHotelSelectedPeriod] = useState("");

  const [gstRowData, setGstRowData]             = useState([]);
  const [gstColDefs, setGstColDefs]             = useState([]);
  const [gstLoading, setGstLoading]             = useState(false);
  const [gstPeriods, setGstPeriods]             = useState([]);
  const [gstSelectedPeriod, setGstSelectedPeriod] = useState("");

  const airlineGridRef = useRef(); const hotelGridRef = useRef(); const gstGridRef = useRef();
  const airlineApiRef  = useRef(null); const hotelApiRef = useRef(null); const gstApiRef = useRef(null);

  const [selectedGroup, setSelectedGroup]           = useState(null);
  const [selectedClientType, setSelectedClientType] = useState(null);

  const [isModalOpen, setIsModalOpen]             = useState(false);
  const [modalValue, setModalValue]               = useState("");
  const [editingRow, setEditingRow]               = useState(null);
  const [isAddPmModalOpen, setIsAddPmModalOpen]   = useState(false);
  const [newPmData, setNewPmData]                 = useState({ name:"", email:"", contact:"", tmc:tmcName });
  const [showDeleteModal, setShowDeleteModal]     = useState(false);
  const [rowToDelete, setRowToDelete]             = useState(null);
  const [isAddRowModalOpen, setIsAddRowModalOpen] = useState(false);
  const [newRowData, setNewRowData]               = useState({
    "Workspace_Active11":"","Workspace-Trade_Name":"","Ticket_Number Count":"",
    "Total K3":"","Commercial":"","Closing Date":"","Contact":"",
    "Next Step":"","PM Email ID":"","PM Name":"","Customer Code":"",
    "GST Number":"","Legal_Entity_Name":"",
  });
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  const updateTimeoutRef  = useRef(null);
  const pendingUpdatesRef = useRef(new Set());

  const getActiveApi = useCallback(() => {
    if (activeSectionRef.current === 'hotel') return hotelApiRef.current;
    if (activeSectionRef.current === 'gst')   return gstApiRef.current;
    return airlineApiRef.current;
  }, []);

  // ── Pinned totals ─────────────────────────────────────────────────
  const updatePinnedTotals = useCallback(() => {
    const api = getActiveApi();
    if (!api) return;

    let totalTransaction = 0, totalK3 = 0, totalPotentialRevenue = 0;
    api.forEachNodeAfterFilter(node => {
      const d = node.data;
      totalTransaction      += parseFloat(String(d["Ticket_Number Count"] || "0").replace(/,/g, '')) || 0;
      totalK3               += parseFloat(String(d["Total K3"]            || "0").replace(/,/g, '')) || 0;
      totalPotentialRevenue += parseFloat(d["Potential Revenue"] || 0) || 0;
    });

    const fmt  = (n) => n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const fmtN = (n) => n.toLocaleString('en-IN');

    api.setGridOption('pinnedBottomRowData', [{
      "Workspace-Trade_Name": "📊 TOTAL",
      "Ticket_Number Count":  fmtN(Math.round(totalTransaction)),
      "Total K3":             fmtN(Math.round(totalK3)),
      "Commercial":           "—",
      "Potential Revenue":    fmt(totalPotentialRevenue),
    }]);
  }, [getActiveApi]);

  // ── Cell renderers ────────────────────────────────────────────────
  const renderDropdownIcon = (params) => (
    <div style={{ display:'flex', alignItems:'center', gap:'6px', justifyContent:'space-around' }}>
      <span>{params.value?.trim() || "Select"}</span>
      <span style={{ fontSize:'12px', color:'#999' }}>▼</span>
    </div>
  );

  const renderClientType = (params) => {
    const value = params.value;
    const styleMap = {
      'Prospect':   { bg:'#E0F2FE', color:'#0369A1' },
      'Demo Done':  { bg:'#DCFCE7', color:'#15803D' },
      'Partnership':{ bg:'#FEF9C3', color:'#92400E' },
      'Lost':       { bg:'#FEE2E2', color:'#B91C1C' },
      'Direct':     { bg:'#F3E8FF', color:'#7E22CE' },
    };
    const style = styleMap[value] || (value === `Lost By ${tmcName}` ? { bg:'#F3E8FF', color:'#B91C1C' } : { bg:'#f1f5f9', color:'#374151' });
    return (
      <div style={{ display:'flex', alignItems:'center', gap:'6px', justifyContent:'space-between' }}>
        <span style={{ backgroundColor:style.bg, color:style.color, padding:'1px 10px', height:'28px', borderRadius:'12px', fontSize:'12px', fontWeight:500, whiteSpace:'nowrap', display:'flex', alignItems:'center' }}>{value}</span>
        <span style={{ fontSize:'10px', color:'#aaa' }}>▼</span>
      </div>
    );
  };

  const renderEditIconText = (params) => (
    <div style={{ display:'flex', alignItems:'center', gap:'4px', maxWidth:'100%' }}>
      <span style={{ whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', flex:1, maxWidth:'180px', display:'inline-block' }}>{params.value}</span>
      <span style={{ fontSize:'12px', color:'#aaa', marginTop:'10px' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path d="M6.77051 5.83343H5.93717C5.49515 5.83343 5.07122 6.00903 4.75866 6.32159C4.4461 6.63415 4.27051 7.05807 4.27051 7.5001V15.0001C4.27051 15.4421 4.4461 15.8661 4.75866 16.1786C5.07122 16.4912 5.49515 16.6668 5.93717 16.6668H13.4372C13.8792 16.6668 14.3031 16.4912 14.6157 16.1786C14.9282 15.8661 15.1038 15.4421 15.1038 15.0001V14.1668M14.2705 4.16677L16.7705 6.66677M17.9247 5.48759C18.2529 5.15938 18.4373 4.71424 18.4373 4.25009C18.4373 3.78594 18.2529 3.34079 17.9247 3.01259C17.5965 2.68438 17.1513 2.5 16.6872 2.5C16.223 2.5 15.7779 2.68438 15.4497 3.01259L8.43717 10.0001V12.5001H10.9372L17.9247 5.48759Z" stroke="#0A8394" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    </div>
  );

  const renderCalendarIcon = (params) => {
    const val = params.value; let display = '', showIcon = true;
    try {
      if (val) {
        const date = new Date(val);
        if (!isNaN(date)) { display = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`; showIcon = false; }
        else { display = val; }
      }
    } catch (e) {}
    return <div style={{ display:'flex', alignItems:'center', gap:'6px' }}><span>{display}</span>{showIcon && <img src={cal} alt="cal" height={18}/>}</div>;
  };

  // ── Cell value changed ────────────────────────────────────────────
  const handleCellValueChanged = useCallback(async (params, sectionType) => {
    const updatedField = params.colDef.field, oldValue = params.oldValue;
    let updatedValue = params.newValue;
    const rowNode = params.node, updatedRow = rowNode.data;
    const type = sectionType || activeSectionRef.current;
    const updateKey = `${updatedRow._id}-${updatedField}-${type}`;
    if (pendingUpdatesRef.current.has(updateKey)) return;
    pendingUpdatesRef.current.add(updateKey);
    if (updateTimeoutRef.current) clearTimeout(updateTimeoutRef.current);
    updateTimeoutRef.current = setTimeout(async () => {
      try {
        if (type === 'airline' && updatedField === 'Commercial' && updatedRow['Total K3']) {
          const percent = parseFloat(updatedValue.replace('%','')) || 0;
          const k3 = parseFloat((updatedRow['Total K3']||"0").replace(/,/g,''));
          updatedRow['Potential Revenue'] = ((percent * k3) / 100).toFixed(2);
        }
        await fetch(`${BASE_URL}/update-tmc-details`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ id:updatedRow._id, source:tmcName, type, updatedBy:localStorage.getItem("bcd_email"), field:updatedField, value:updatedValue }) });
        const rowIdentifier = updatedRow["Workspace-Trade_Name"]||updatedRow["Client Name"]||updatedRow["PM Name"]||Object.entries(updatedRow).find(([k,v])=>k.toLowerCase().includes("name")&&typeof v==="string"&&v.trim())?.[1]||updatedRow["_id"]||"Unknown";
        await fetch(`${BASE_URL}/log-tmc-change`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ row:rowIdentifier, column:updatedField, oldValue, newValue:updatedValue, type, updatedBy:localStorage.getItem("bcd_email"), timestamp:new Date().toISOString() }) });
        rowNode.setData({ ...updatedRow });
      } catch (err) { console.error("Update failed", err); }
      finally { pendingUpdatesRef.current.delete(updateKey); }
    }, 300);
  }, [tmcName]);

  const handleNextStepEdit = (params) => { setEditingRow(params.node); setModalValue(params.value||""); setIsModalOpen(true); };
  const handleModalSave = async () => {
    if (editingRow) { editingRow.data['Next Step'] = modalValue; await handleCellValueChanged({ node:editingRow, newValue:modalValue, oldValue:editingRow.data['Next Step'], colDef:{ field:'Next Step' } }, activeSectionRef.current); }
    setIsModalOpen(false); setEditingRow(null);
  };

  // ── Number formatters ─────────────────────────────────────────────
  const numFmt = (p) => {
    if (!p.value) return '';
    const n = parseFloat(String(p.value).replace(/,/g,''));
    return isNaN(n) ? p.value : n.toLocaleString('en-IN');
  };
  const revFmt = (p) => {
    if (!p.value && p.value !== 0) return '';
    const n = parseFloat(String(p.value).replace(/,/g,''));
    return isNaN(n) ? p.value : n.toLocaleString('en-IN', { minimumFractionDigits:2, maximumFractionDigits:2 });
  };

  // ── Column builders ───────────────────────────────────────────────
  const buildCommonColumns = useCallback((pmOpts, sectionType) => {
    const commonLastCols = [
      { field:"Last activity", headerName:"Last Activity", filter:'agTextColumnFilter', floatingFilter:true,
        valueFormatter:(p) => { if (!p.value) return ''; try { const d=new Date(p.value); if (isNaN(d.getTime())) return p.value; const pad=n=>String(n).padStart(2,'0'); const h24=d.getHours(),h12=h24%12||12; return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(h12)}:${pad(d.getMinutes())} ${h24>=12?'PM':'AM'}`; } catch { return p.value; } } },
      { field:"Update by", headerName:"Updated By", filter:'agTextColumnFilter', floatingFilter:true },
    ];
    return [
      { field:"Workspace-Trade_Name", headerName:"Client Name", editable:true, filter:'agSetColumnFilter', floatingFilter:true, cellStyle:{ whiteSpace:'normal', textAlign:'center', display:'flex', alignItems:'center', justifyContent:'center', padding:'4px', lineHeight:'1.2' } },
      { field:"GST Number", headerName:"GST Number", filter:'agTextColumnFilter', floatingFilter:true },
      { field:"Legal_Entity_Name", headerName:"Legal Entity Name", filter:'agTextColumnFilter', floatingFilter:true, width:sectionType==='airline'?500:400 },
      {
        headerName:"Account Manager Details",
        children:[
          { headerName:"Account Manager Name", field:"PM Name", editable:true, cellEditor:'agSelectCellEditor',
            cellEditorParams:(p)=>({ values:['',...pmOpts], cellEditorPopup:true, value:p.value||'' }),
            onCellValueChanged:(p)=>{ if (p.newValue==='+ Add New Account Manager...') { setIsAddPmModalOpen(true); p.node.setDataValue("PM Name",''); return; } p.node.setDataValue("PM Name",p.newValue); handleCellValueChanged(p,sectionType); },
            cellRenderer:renderDropdownIcon, floatingFilter:true, filter:'agSetColumnFilter' },
          { headerName:"Account Manager Email ID", field:"PM Email ID", columnGroupShow:'open', editable:true, floatingFilter:true, filter:'agTextColumnFilter' },
          { field:"Contact", columnGroupShow:'open', editable:true, floatingFilter:true, filter:'agTextColumnFilter' },
        ],
      },
      { field:"Workspace_Active11", headerName:"Client Type", editable:true, cellEditor:'agSelectCellEditor', cellEditorParams:{ values:clientTypeOptions }, cellRenderer:renderClientType, filter:"agSetColumnFilter", floatingFilter:true },
      { field:"Closing Date", headerName:"Closing Date", editable:true, cellEditor:'agDateCellEditor', cellEditorParams:{ useBrowserDatePicker:true },
        valueFormatter:(p)=>p.value?new Date(p.value).toISOString().split('T')[0]:'',
        valueParser:(p)=>{ if (!p.newValue) return null; const [y,m,d]=p.newValue.split('-').map(Number); return new Date(Date.UTC(y,m-1,d)).toISOString(); },
        cellRenderer:renderCalendarIcon, filter:'agDateColumnFilter', floatingFilter:true },
      { field:"Next Step", headerName:"Next Step", editable:false, cellRenderer:renderEditIconText, onCellClicked:handleNextStepEdit, filter:'agTextColumnFilter', floatingFilter:true },
      ...commonLastCols,
    ];
  }, [handleCellValueChanged]);

  const buildAirlineColumns = useCallback((pmOpts) => [
    ...buildCommonColumns(pmOpts, 'airline'),
    {
      headerName:"Summary", headerClass:"summary-group-header",
      children:[
        { field:"Ticket_Number Count", headerName:"Transaction",      headerClass:"summary-child-header", cellClass:"summary-cell", filter:'agTextColumnFilter', floatingFilter:true, valueFormatter:numFmt },
        { field:"Total K3",            headerName:"K3",               headerClass:"summary-child-header", cellClass:"summary-cell", filter:'agTextColumnFilter', floatingFilter:true, valueFormatter:numFmt },
        { field:"Commercial",          headerName:"Commercial %", editable:true, headerClass:"summary-child-header", cellClass:"summary-cell", filter:'agTextColumnFilter', floatingFilter:true },
        { field:"Potential Revenue",   headerName:"Potential Revenue", headerClass:"summary-child-header", cellClass:"summary-cell", filter:'agTextColumnFilter', floatingFilter:true, valueFormatter:revFmt },
        { field:"period", headerName:"Period", filter:"agTextColumnFilter", floatingFilter:true, hide:true },
      ],
    },
  ], [buildCommonColumns]);

  const buildHotelColumns = useCallback((pmOpts) => [
    ...buildCommonColumns(pmOpts, 'hotel'),
    { field:"period", headerName:"Period", filter:"agTextColumnFilter", floatingFilter:true, hide:true },
  ], [buildCommonColumns]);

  const buildGstColumns = useCallback((pmOpts) => [
    ...buildCommonColumns(pmOpts, 'gstin'),
    { field:"period", headerName:"Period", filter:"agTextColumnFilter", floatingFilter:true, hide:true },
  ], [buildCommonColumns]);

  // ── Section loader ────────────────────────────────────────────────
  const loadSection = useCallback(async (type, setPmOpts, setLoading, setPeriods, setColDefs, setRowData, buildColumns) => {
    try {
      setLoading(true);
      const pmRes = await fetch(`${BASE_URL}/account-managers?tmcName=${tmcName}&type=${type}`);
      const managers = await pmRes.json();
      const pmNames = [...new Set(managers.map(m=>m.name).filter(n=>n?.trim()))];
      const finalPmOpts = pmNames.length > 0 ? [...pmNames,'+ Add New Account Manager...'] : [...pmOptionsFallback,'+ Add New Account Manager...'];
      setPmOpts(finalPmOpts);
      const tmcRes = await fetch(`${BASE_URL}/tmc-details`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ source:tmcName, type }) });
      const data = await tmcRes.json();
      setPeriods([...new Set(data.map(i=>i.period).filter(p=>p?.trim()))]);
      const cleaned = data.map(({ _id, SOURCE, period, ...rest }) => {
        if (type === 'airline') { const comm=parseFloat((rest["Commercial"]||"0").replace("%","")); const k3=parseFloat((rest["Total K3"]||"0").replace(/,/g,'')); return { _id, source:SOURCE, period, ...rest, "Potential Revenue":((comm*k3)/100).toFixed(2) }; }
        return { _id, source:SOURCE, period, ...rest };
      });
      setColDefs(buildColumns(finalPmOpts)); setRowData(cleaned);
    } catch (err) { console.error(`Error loading ${type}:`, err); }
    finally { setLoading(false); }
  }, [tmcName]);

  useEffect(() => {
    loadSection('airline', setAirlinePmOptions, setAirlineLoading, setAirlinePeriods, setAirlineColDefs, setAirlineRowData, buildAirlineColumns);
    loadSection('hotel',   setHotelPmOptions,   setHotelLoading,   setHotelPeriods,   setHotelColDefs,   setHotelRowData,   buildHotelColumns);
    loadSection('gstin',   setGstPmOptions,     setGstLoading,     setGstPeriods,     setGstColDefs,     setGstRowData,     buildGstColumns);
  }, []);

  useEffect(() => () => { if (updateTimeoutRef.current) clearTimeout(updateTimeoutRef.current); }, []);

  const handleSectionChange = (section) => {
    setActiveSection(section); activeSectionRef.current = section;
    setSelectedGroup(null); setSelectedClientType(null);
    setAirlineSelectedPeriod(""); setHotelSelectedPeriod(""); setGstSelectedPeriod("");
    setTimeout(() => updatePinnedTotals(), 100);
  };

  // ── Filter helpers ────────────────────────────────────────────────
  const applyClientTypeFilter = useCallback((values) => {
    let api = airlineApiRef.current;
    if (activeSectionRef.current==='hotel') api = hotelApiRef.current;
    if (activeSectionRef.current==='gst')   api = gstApiRef.current;
    if (!api) return;
    api.setFilterModel(values?.length ? { Workspace_Active11:{ filterType:'set', values } } : null);
    api.onFilterChanged();
  }, []);

  const handleCardGroupClick = useCallback((group) => {
    if (selectedGroup===group) { setSelectedGroup(null); setSelectedClientType(null); applyClientTypeFilter(null); return; }
    setSelectedGroup(group); setSelectedClientType(null);
    applyClientTypeFilter(group==='action' ? ['Prospect','Demo Done','Lost'] : ['Partnership','Direct',`Lost By ${tmcName}`]);
  }, [selectedGroup, applyClientTypeFilter, tmcName]);

  const handleClientTypeClick = useCallback((clientType) => {
    if (selectedClientType===clientType) { setSelectedClientType(null); setSelectedGroup(null); applyClientTypeFilter(null); return; }
    setSelectedClientType(clientType); setSelectedGroup(null); applyClientTypeFilter([clientType]);
  }, [selectedClientType, applyClientTypeFilter]);

  const handleSearch = (e) => { const api=getActiveApi(); if (api?.setGridOption) api.setGridOption('quickFilterText', e.target.value); };
  const handleExport = ()  => { const api=getActiveApi(); api?.exportDataAsCsv({ fileName:`${tmcName}-${activeSection}-data.csv` }); };

  const handlePeriodChange = (value) => {
    const api = getActiveApi();
    if (activeSection==='hotel') setHotelSelectedPeriod(value);
    else if (activeSection==='gst') setGstSelectedPeriod(value);
    else setAirlineSelectedPeriod(value);
    if (!api) return;
    api.setFilterModel(value ? { period:{ filterType:'text', type:'equals', filter:value } } : null);
    api.onFilterChanged();
  };

  const handleLogout = () => { localStorage.removeItem("bcd_token"); localStorage.removeItem("bcd_email"); window.location.href="/login"; };

  // ── Metrics ───────────────────────────────────────────────────────
  const activeRowData = activeSection==='hotel' ? hotelRowData : activeSection==='gst' ? gstRowData : airlineRowData;
  const countByType   = (data, type) => data.filter(r=>r["Workspace_Active11"]===type).length;
  const revenueByType = (data, type) => data.filter(r=>r["Workspace_Active11"]===type).reduce((s,r)=>s+parseFloat(r["Potential Revenue"]||0),0).toFixed(2);
  const typeClass = (label) => ({'Prospect':'prospect','Demo Done':'demodone','Lost':'lost','Partnership':'partnership','Direct':'direct'}[label]??'lostby');
  const formatRevenue = (val) => { const n=parseFloat(val)||0; if (!n) return '₹0'; const s=Math.round(n).toString(); if (s.length<=3) return '₹'+s; let r=s.slice(-3); const rest=s.slice(0,-3); for (let i=rest.length;i>0;i-=2) r=rest.slice(Math.max(0,i-2),i)+','+r; return '₹'+r; };

  const renderAirlineCard = (label, rowData) => {
    const count=countByType(rowData,label), revenue=revenueByType(rowData,label), isSelected=selectedClientType===label, tc=typeClass(label);
    return <div key={label} className={`fk-row-item type-${tc} ${isSelected?'active-item':''}`} onClick={(e)=>{ e.stopPropagation(); handleClientTypeClick(label); }}><span className={`fk-type-dot dot-${tc}`}/><span className="fk-row-label">{label}</span><span className="fk-row-count">{count}</span><span className="fk-row-revenue">{formatRevenue(revenue)}</span><span className="fk-row-chevron">›</span></div>;
  };
  const renderHotelCard = (label, rowData) => {
    const count=countByType(rowData,label), isSelected=selectedClientType===label, tc=typeClass(label);
    return <div key={label} className={`fk-hotel-stat type-${tc} ${isSelected?'active-stat':''}`} onClick={(e)=>{ e.stopPropagation(); handleClientTypeClick(label); }}><div className="fk-hotel-count">{count}</div><div className="fk-hotel-label">{label}</div></div>;
  };

  // ── Derived ───────────────────────────────────────────────────────
  const currentLoading   = activeSection==='hotel'?hotelLoading:activeSection==='gst'?gstLoading:airlineLoading;
  const currentPeriods   = activeSection==='hotel'?hotelPeriods:activeSection==='gst'?gstPeriods:airlinePeriods;
  const currentPeriod    = activeSection==='hotel'?hotelSelectedPeriod:activeSection==='gst'?gstSelectedPeriod:airlineSelectedPeriod;
  const airlineGridReady = airlineColDefs.length>0;
  const hotelGridReady   = hotelColDefs.length>0;
  const gstGridReady     = gstColDefs.length>0;

  const onGridReady = useCallback((params, ref) => {
    ref.current = params.api;
    setTimeout(() => updatePinnedTotals(), 50);
  }, [updatePinnedTotals]);

  const onFilterChanged = useCallback(() => {
    updatePinnedTotals();
  }, [updatePinnedTotals]);

  return (
    <div style={{ padding:"40px 40px" }} className="detailed-data-page">
      <style>{globalStyles}</style>

      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"20px" }}>
        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <img src={fk} alt="Finkraft Logo" style={{ height:'50px', width:'50px' }}/>
          <div style={{ width:'3px', height:'40px', backgroundColor:'black' }}/>
          <img src={BCDLogo} alt="BCD Logo" style={{ height:'55px', width:'160px', marginBottom:'15px' }}/>
        </div>
        <Button danger icon={<LogoutOutlined/>} onClick={()=>setShowLogoutPopup(true)}>Logout</Button>
      </div>

      {/* Tabs */}
      <div className="section-nav">
        <button className={`section-tab ${activeSection==='airline'?'active':''}`} onClick={()=>handleSectionChange('airline')}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M21 16V14L13 9V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V9L2 14V16L10 13.5V19L8 20.5V22L11.5 21L15 22V20.5L13 19V13.5L21 16Z"/></svg>
          Airline <span className="tab-badge">{airlineRowData.length}</span>
        </button>
        <button className={`section-tab ${activeSection==='hotel'?'active':''}`} onClick={()=>handleSectionChange('hotel')}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M7 13C8.66 13 10 11.66 10 10C10 8.34 8.66 7 7 7C5.34 7 4 8.34 4 10C4 11.66 5.34 13 7 13ZM19 7H11V14H3V5H1V20H3V17H21V20H23V11C23 8.79 21.21 7 19 7Z"/></svg>
          Hotel {hotelLoading?<span className="tab-badge" style={{ background:'#f3f4f6',color:'#9ca3af' }}>…</span>:<span className="tab-badge">{hotelRowData.length}</span>}
        </button>
        <button className={`section-tab gst-tab ${activeSection==='gst'?'active':''}`} onClick={()=>handleSectionChange('gst')}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"/></svg>
          GST {gstLoading?<span className="tab-badge" style={{ background:'#ede9fe',color:'#9ca3af' }}>…</span>:<span className="tab-badge">{gstRowData.length}</span>}
        </button>
      </div>

      {/* Cards */}
      <div className="card-section">
        <div className={`fk-stat-card action-card ${selectedGroup==='action'?'selected-card':''}`} onClick={()=>handleCardGroupClick('action')}>
          <div className="fk-card-header-band">
            <div className="fk-card-header-left"><svg width="15" height="15" viewBox="0 0 20 20" fill="none"><path d="M11.0825 2.623L18.278 15.085c.22.385-.055.875-.5.875H2.805c-.446 0-.72-.49-.5-.875L8.918 2.623c.48-.833 1.683-.833 2.164 0ZM10 12.5a.833.833 0 100 1.667.833.833 0 000-1.667Zm0-5.833c-.46 0-.833.373-.833.833v3.333a.833.833 0 001.667 0V7.5A.833.833 0 0010 6.667Z" fill="rgba(255,255,255,0.95)"/></svg><p className="fk-card-title">Action Required</p></div>
            <span className="fk-card-total-badge">{`${['Prospect','Demo Done','Lost'].reduce((s,t)=>s+countByType(activeRowData,t),0)} clients`}</span>
          </div>
          <div className="fk-card-body">
            {activeSection==='airline'
              ? <div className="fk-card-rows">{renderAirlineCard('Prospect',activeRowData)}{renderAirlineCard('Demo Done',activeRowData)}{renderAirlineCard('Lost',activeRowData)}</div>
              : <div className="fk-hotel-grid">{renderHotelCard('Prospect',activeRowData)}{renderHotelCard('Demo Done',activeRowData)}{renderHotelCard('Lost',activeRowData)}</div>}
          </div>
        </div>

        <div className={`fk-stat-card good-card ${selectedGroup==='good'?'selected-card':''}`} onClick={()=>handleCardGroupClick('good')}>
          <div className="fk-card-header-band">
            <div className="fk-card-header-left"><svg width="15" height="15" viewBox="0 0 20 20" fill="none"><path d="M10 1.667C5.4 1.667 1.667 5.4 1.667 10S5.4 18.333 10 18.333 18.333 14.6 18.333 10 14.6 1.667 10 1.667Zm-1.667 12.5L4.167 10l1.175-1.175 2.991 2.983 6.325-6.325L15.833 6.667l-7.5 7.5Z" fill="rgba(255,255,255,0.95)"/></svg><p className="fk-card-title">Good Standing</p></div>
            <span className="fk-card-total-badge">{`${['Partnership','Direct',`Lost By ${tmcName}`].reduce((s,t)=>s+countByType(activeRowData,t),0)} clients`}</span>
          </div>
          <div className="fk-card-body">
            {activeSection==='airline'
              ? <div className="fk-card-rows">{renderAirlineCard('Partnership',activeRowData)}{renderAirlineCard('Direct',activeRowData)}{renderAirlineCard(`Lost By ${tmcName}`,activeRowData)}</div>
              : <div className="fk-hotel-grid">{renderHotelCard('Partnership',activeRowData)}{renderHotelCard('Direct',activeRowData)}{renderHotelCard(`Lost By ${tmcName}`,activeRowData)}</div>}
          </div>
        </div>
      </div>

      {/* Toolbar — search + period only */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
        <div style={{ display:'flex', gap:'10px', alignItems:'center' }}>
          <Input
            placeholder="🔍 Search …"
            style={{ width:220, borderRadius:8 }}
            allowClear
            onChange={handleSearch}
          />
          <select
            style={{ width:220, padding:"6px 10px", borderRadius:"8px", border:"1px solid #d9d9d9", fontSize:13, height:32 }}
            value={currentPeriod}
            onChange={(e) => handlePeriodChange(e.target.value)}
          >
            <option value="">All Periods</option>
            {currentPeriods.map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
        <div style={{ display:'flex', gap:'10px' }}>
          <Button icon={<DownloadOutlined/>} onClick={handleExport} style={{ backgroundColor:'#f0f5ff', color:'#1677ff' }}>Export</Button>
          <Button icon={<ReloadOutlined/>} onClick={()=>window.location.reload()} style={{ backgroundColor:'#f0f5ff', color:'#1677ff' }}>Reload</Button>
        </div>
      </div>

      {/* Grid */}
      <div style={{ position:'relative', height:"80vh" }}>
        <Spin spinning={currentLoading} tip="Loading data..." size="large" style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', zIndex:10 }}/>
        <div style={{ height:"100%", opacity:currentLoading?0.3:1 }}>
          <div className="ag-theme-alpine" style={{ height:"100%" }}>

            <div style={{ height:'100%', display:activeSection==='airline'?'block':'none' }}>
              {airlineGridReady && (
                <AgGridReact
                  ref={airlineGridRef} rowData={airlineRowData} columnDefs={airlineColDefs}
                  defaultColDef={{ sortable:true, filter:true, resizable:true }}
                  onCellValueChanged={(p)=>{ if (p.colDef.field==="PM Name") return; handleCellValueChanged(p,'airline'); }}
                  groupDisplayType="multipleColumns" singleClickEdit={true} stopEditingWhenCellsLoseFocus={true}
                  onFilterChanged={onFilterChanged} onGridReady={(p)=>onGridReady(p,airlineApiRef)}
                />
              )}
            </div>

            <div style={{ height:'100%', display:activeSection==='hotel'?'block':'none' }}>
              {hotelGridReady && (
                <AgGridReact
                  ref={hotelGridRef} rowData={hotelRowData} columnDefs={hotelColDefs}
                  defaultColDef={{ sortable:true, filter:true, resizable:true }}
                  onCellValueChanged={(p)=>{ if (p.colDef.field==="PM Name") return; handleCellValueChanged(p,'hotel'); }}
                  groupDisplayType="multipleColumns" singleClickEdit={true} stopEditingWhenCellsLoseFocus={true}
                  onFilterChanged={onFilterChanged} onGridReady={(p)=>onGridReady(p,hotelApiRef)}
                />
              )}
            </div>

            <div style={{ height:'100%', display:activeSection==='gst'?'block':'none' }}>
              {gstGridReady && (
                <AgGridReact
                  ref={gstGridRef} rowData={gstRowData} columnDefs={gstColDefs}
                  defaultColDef={{ sortable:true, filter:true, resizable:true }}
                  onCellValueChanged={(p)=>{ if (p.colDef.field==="PM Name") return; handleCellValueChanged(p,'gstin'); }}
                  groupDisplayType="multipleColumns" singleClickEdit={true} stopEditingWhenCellsLoseFocus={true}
                  onFilterChanged={onFilterChanged} onGridReady={(p)=>onGridReady(p,gstApiRef)}
                />
              )}
            </div>

          </div>
        </div>
      </div>

      {/* Modals */}
      <Modal title="Edit Next Step" open={isModalOpen} onOk={handleModalSave} onCancel={()=>setIsModalOpen(false)}
        footer={[<Button key="cancel" onClick={()=>setIsModalOpen(false)}>Cancel</Button>,<Button key="save" type="primary" onClick={handleModalSave}>Save</Button>]}>
        <Input.TextArea rows={6} value={modalValue} onChange={(e)=>setModalValue(e.target.value)}/>
      </Modal>

      <Modal title="Add New Account Manager" open={isAddPmModalOpen} onCancel={()=>setIsAddPmModalOpen(false)} centered
        footer={[<Button key="cancel" onClick={()=>setIsAddPmModalOpen(false)}>Cancel</Button>,
          <Button key="save" type="primary" onClick={async()=>{
            if (!newPmData.name||!newPmData.tmc) return alert("Name and TMC are required.");
            const name=newPmData.name.trim();
            const curOpts=activeSectionRef.current==='hotel'?hotelPmOptions:activeSectionRef.current==='gst'?gstPmOptions:airlinePmOptions;
            if (curOpts.includes(name)) { alert("Already exists."); return; }
            try {
              await fetch(`${BASE_URL}/add-account-manager`,{ method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ ...newPmData, type:activeSectionRef.current==='gst'?'gstin':activeSectionRef.current }) });
              const updated=[...curOpts.filter(o=>o!=='+ Add New Account Manager...'),name,'+ Add New Account Manager...'];
              if (activeSectionRef.current==='hotel') setHotelPmOptions(updated); else if (activeSectionRef.current==='gst') setGstPmOptions(updated); else setAirlinePmOptions(updated);
              const rowId=editingRow?.data?._id;
              if (rowId) {
                const st=activeSectionRef.current==='gst'?'gstin':activeSectionRef.current;
                for (const {field,value} of [{field:"PM Name",value:newPmData.name},{field:"PM Email ID",value:newPmData.email},{field:"Contact",value:newPmData.contact}]) {
                  await fetch(`${BASE_URL}/update-tmc-details`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:rowId,source:newPmData.tmc,type:st,updatedBy:localStorage.getItem("bcd_email"),field,value})});
                }
                editingRow.setDataValue("PM Name",newPmData.name); editingRow.setDataValue("PM Email ID",newPmData.email); editingRow.setDataValue("Contact",newPmData.contact);
              }
              setNewPmData({name:"",email:"",contact:"",tmc:tmcName}); setIsAddPmModalOpen(false); setEditingRow(null);
            } catch { alert("Failed to save."); }
          }}>Save</Button>]}>
        <div style={{ display:'flex', flexDirection:'column', gap:'12px' }}>
          {[{label:"Account Manager Name",key:"name",required:true,ph:"Enter name"},{label:"Email ID",key:"email",ph:"Enter email"},{label:"Contact",key:"contact",ph:"Enter contact"},{label:"TMC Name",key:"tmc",required:true,ph:"Enter TMC"}]
            .map(({label,key,required,ph})=>(
              <div key={key}><label style={{fontWeight:500}}>{label}{required&&<span style={{color:'red'}}> *</span>}</label><Input placeholder={ph} value={newPmData[key]} onChange={(e)=>setNewPmData(p=>({...p,[key]:e.target.value}))}/></div>
            ))}
        </div>
      </Modal>

      <Modal title="Add New Row" open={isAddRowModalOpen} onCancel={()=>setIsAddRowModalOpen(false)}
        footer={[<Button key="cancel" onClick={()=>setIsAddRowModalOpen(false)}>Cancel</Button>,
          <Button key="submit" type="primary" onClick={async()=>{
            const st=activeSectionRef.current==='gst'?'gstin':activeSectionRef.current;
            const payload={...newRowData,SOURCE:tmcName,type:st,"Update by":localStorage.getItem("bcd_email"),"Last activity":new Date().toISOString()};
            try {
              const res=await fetch(`${BASE_URL}/add-tmc-row`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
              const result=await res.json();
              if (res.ok) {
                const comm=parseFloat(newRowData["Commercial"]||0),k3=parseFloat((newRowData["Total K3"]||"0").replace(/,/g,''));
                const newRow={...newRowData,source:tmcName,type:st,"Update by":localStorage.getItem("bcd_email"),"Potential Revenue":((comm*k3)/100).toFixed(2),_id:result.insertedId||Math.random().toString(36).substring(2,9)};
                if (activeSectionRef.current==='hotel') setHotelRowData(p=>[...p,newRow]); else if (activeSectionRef.current==='gst') setGstRowData(p=>[...p,newRow]); else setAirlineRowData(p=>[...p,newRow]);
                setIsAddRowModalOpen(false);
                setNewRowData({"Workspace_Active11":"","Workspace-Trade_Name":"","Ticket_Number Count":"","Total K3":"","Commercial":"","Closing Date":"","Contact":"","Next Step":"","PM Email ID":"","PM Name":"","Customer Code":"","GST Number":"","Legal_Entity_Name":""});
              } else { alert("Failed to add row."); }
            } catch { alert("Something went wrong."); }
          }}>Save</Button>]}>
        <div style={{ display:"flex", flexDirection:"column", gap:"12px" }}>
          <div><label>Client Type</label><select style={{width:"100%",padding:"8px"}} value={newRowData["Workspace_Active11"]} onChange={e=>setNewRowData(p=>({...p,"Workspace_Active11":e.target.value}))}><option value="">Select</option>{clientTypeOptions.map(t=><option key={t} value={t}>{t}</option>)}</select></div>
          <div><label>Workspace</label><Input value={newRowData["Workspace-Trade_Name"]} onChange={e=>setNewRowData(p=>({...p,"Workspace-Trade_Name":e.target.value}))}/></div>
          <div><label>Transaction Count</label><Input type="number" value={newRowData["Ticket_Number Count"]} onChange={e=>setNewRowData(p=>({...p,"Ticket_Number Count":e.target.value}))}/></div>
          <div><label>Account Manager</label>
            <select style={{width:"100%",padding:"8px",borderRadius:"6px",border:"1px solid #d9d9d9"}} value={newRowData["PM Name"]||''} onChange={e=>{ const v=e.target.value; if (v==='+ Add New Account Manager...') { setNewRowData(p=>({...p,"PM Name":''})); setIsAddRowModalOpen(false); setIsAddPmModalOpen(true); return; } setNewRowData(p=>({...p,"PM Name":v})); }}>
              <option value="">Select</option>
              {(activeSectionRef.current==='hotel'?hotelPmOptions:activeSectionRef.current==='gst'?gstPmOptions:airlinePmOptions).map(o=><option key={o} value={o}>{o}</option>)}
            </select>
          </div>
          <div><label>Total K3</label><Input type="number" value={newRowData["Total K3"]} onChange={e=>setNewRowData(p=>({...p,"Total K3":e.target.value}))}/></div>
          <div><label>Contact</label><Input value={newRowData["Contact"]} onChange={e=>setNewRowData(p=>({...p,"Contact":e.target.value}))}/></div>
          <div><label>Next Step</label><Input.TextArea value={newRowData["Next Step"]} onChange={e=>setNewRowData(p=>({...p,"Next Step":e.target.value}))}/></div>
          <div><label>Account Manager Email</label><Input value={newRowData["PM Email ID"]} onChange={e=>setNewRowData(p=>({...p,"PM Email ID":e.target.value}))}/></div>
          <div><label>Commercial %</label><Input type="number" value={newRowData["Commercial"]} onChange={e=>setNewRowData(p=>({...p,"Commercial":e.target.value}))}/></div>
          <div><label>Customer Code</label><Input value={newRowData["Customer Code"]} onChange={e=>setNewRowData(p=>({...p,"Customer Code":e.target.value}))}/></div>
          <div><label>GST Number</label><Input value={newRowData["GST Number"]} onChange={e=>setNewRowData(p=>({...p,"GST Number":e.target.value}))}/></div>
          <div><label>Legal Entity Name</label><Input value={newRowData["Legal_Entity_Name"]} onChange={e=>setNewRowData(p=>({...p,"Legal_Entity_Name":e.target.value}))}/></div>
          <div><label>Closing Date</label><DatePicker style={{width:"100%"}} value={newRowData["Closing Date"]?dayjs(newRowData["Closing Date"]):null} onChange={(_,ds)=>setNewRowData(p=>({...p,"Closing Date":ds}))}/></div>
        </div>
      </Modal>

      <Modal open={showLogoutPopup} onOk={handleLogout} onCancel={()=>setShowLogoutPopup(false)} centered closable={false}
        footer={[<Button key="y" type="primary" danger onClick={handleLogout} style={{fontWeight:'bold'}}>Yes, Logout</Button>,<Button key="n" onClick={()=>setShowLogoutPopup(false)} style={{fontWeight:'bold'}}>No, Stay</Button>]}>
        <h2 style={{fontSize:20,color:'#333',marginBottom:10}}>Confirm Logout</h2>
        <p style={{fontSize:15,color:'#555'}}>Are you sure you want to log out?</p>
      </Modal>

      <Modal open={showDeleteModal} onCancel={()=>setShowDeleteModal(false)} centered closable={false}
        footer={[
          <Button key="del" type="primary" danger style={{fontWeight:'bold'}} onClick={async()=>{
            const data=rowToDelete?.data,api=rowToDelete?.api;
            try {
              const {_id,source}=data;
              if (_id&&source) {
                const st=activeSectionRef.current==='gst'?'gstin':activeSectionRef.current;
                const res=await fetch(`${BASE_URL}/delete-tmc-row`,{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:_id,source,type:st})});
                const result=await res.json();
                if (res.ok) {
                  api.applyTransaction({remove:[data]});
                  const rowId=data["Workspace-Trade_Name"]||data["Client Name"]||_id||"Unknown";
                  await fetch(`${BASE_URL}/log-tmc-change`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({row:rowId,column:"action",oldValue:JSON.stringify(data),newValue:"DELETED",type:st,updatedBy:localStorage.getItem("bcd_email"),timestamp:new Date().toISOString()})});
                  setShowDeleteModal(false); setRowToDelete(null);
                } else { alert("Delete failed: "+result.error); }
              }
            } catch(err) { alert("Error: "+err.message); }
          }}>Yes, Delete</Button>,
          <Button key="cancel" onClick={()=>setShowDeleteModal(false)} style={{fontWeight:'bold'}}>No, Cancel</Button>]}>
        <h2 style={{fontSize:20,color:'#333',marginBottom:10}}>Confirm Deletion</h2>
        <p style={{fontSize:15,color:'#555'}}>This action cannot be undone.</p>
      </Modal>
    </div>
  );
};

export default Dashboard;